import { createContext, useContext } from 'react';

import { AppConfig } from '@/config';

export const AppConfigContext = createContext(AppConfig);

export const useAppConfig = () => {
  return useContext(AppConfigContext);
};
